import axios from 'axios';
import { API_URL } from '../config';

// 建立 axios 實例
const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  // 重要：必須設定 withCredentials 以支援 session cookie
  withCredentials: true,
});

// 請求攔截器
apiClient.interceptors.request.use(
  (config) => {
    // Session cookie 會自動被瀏覽器帶上，不需要手動處理
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 響應攔截器 - 統一錯誤處理
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 檢查是否被重定向到 /login-required (後端的 302 重定向)
    // 當後端返回 302 重定向時,瀏覽器會自動跟隨,最終可能收到 404
    if (error.response) {
      const isLoginRequired = error.response.request?.responseURL?.includes('/login-required');

      if (isLoginRequired || error.response.status === 401) {
        // 拋出自定義錯誤,方便上層組件識別
        const authError = new Error('Authentication required');
        authError.response = { ...error.response, status: 401 };
        return Promise.reject(authError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
